// R251: legacy `app/_components/interaction-guard.tsx` parity. Blocks the
// browser's default context menu and image drag globally so casual users
// can't right-click → "Salvar imagem" or drag-out brand assets. Editable
// elements (inputs, contenteditable) and explicit opt-outs via
// `data-allow-context-menu` / `data-allow-drag` keep working.

import { useEffect } from "react";

const ALLOW_CONTEXT_MENU_SELECTOR = [
  "[data-allow-context-menu]",
  "input",
  "textarea",
  "select",
  "[contenteditable='true']",
  "[role='textbox']",
].join(", ");

const ALLOW_DRAG_SELECTOR = "[data-allow-drag]";

/** Global behaviour guard. Mount once near the top of the React tree. */
export function InteractionGuard(): null {
  useEffect(() => {
    const onContextMenu = (event: MouseEvent): void => {
      if (shouldAllowContextMenu(event.target)) return;
      event.preventDefault();
    };
    const onDragStart = (event: DragEvent): void => {
      if (shouldAllowDrag(event.target)) return;
      event.preventDefault();
    };
    document.addEventListener("contextmenu", onContextMenu);
    document.addEventListener("dragstart", onDragStart);
    return () => {
      document.removeEventListener("contextmenu", onContextMenu);
      document.removeEventListener("dragstart", onDragStart);
    };
  }, []);
  return null;
}

function shouldAllowContextMenu(target: EventTarget | null): boolean {
  return matchesSelector(target, ALLOW_CONTEXT_MENU_SELECTOR);
}

function shouldAllowDrag(target: EventTarget | null): boolean {
  return matchesSelector(target, ALLOW_DRAG_SELECTOR);
}

function matchesSelector(
  target: EventTarget | null,
  selector: string,
): boolean {
  if (!(target instanceof Element)) return false;
  return target.closest(selector) !== null;
}
